import { AxiosError } from 'axios';
import api from '../utils/api';

export interface EmailTemplate {
  _id: string;
  name: string;
  type: string;
  subject: string;
  body: string;
  active: boolean;
}

const BASE_URL = '/email-templates';

// Get all email templates
export const getAllTemplates = async (): Promise<EmailTemplate[]> => {
  
  try {
    const response = await api.get<EmailTemplate[]>(BASE_URL);
    
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Create new email template
export const createTemplate = async (template: Omit<EmailTemplate, '_id'>): Promise<EmailTemplate> => {
  
  try {
    const response = await api.post<EmailTemplate>(BASE_URL, template);
    
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Update email template
export const updateTemplate = async (id: string, template: Partial<EmailTemplate>): Promise<EmailTemplate> => {
  
  try {
    const response = await api.put<EmailTemplate>(`${BASE_URL}/${id}`, template);
    
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Delete email template
export const deleteTemplate = async (id: string): Promise<void> => {
  
  try {
    await api.delete(`${BASE_URL}/${id}`);
    
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Toggle email template status
export const toggleTemplateStatus = async (id: string): Promise<EmailTemplate> => {
  
  try {
    const response = await api.post<EmailTemplate>(`${BASE_URL}/${id}/toggle-status`);
    
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};
